import {
    GET_LESSONS_DETAIL_REQUEST,
    GET_LESSONS_DETAIL_SUCCESS,
    GET_LESSONS_DETAIL_FAILURE,
} from '../actions';


const initialState = {};

const LessonsDetailedReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LESSONS_DETAIL_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_LESSONS_DETAIL_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_LESSONS_DETAIL_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default LessonsDetailedReducer;